import './scss/vitrine.scss'
import { Device } from "../../data/device"
import { ProdutoPrincipal } from "./components/ProdutoPrincipal"
import { ItemOferta } from "./components/ItemOferta"
import { getResourceFromS3 } from '@/utils/getResourceFromS3'
import { isDev } from '@/utils/enviroment-detector'
import type { DestaqueMiniaturaProps } from '../../types/vitrineApp.props'
import { TitleCtn } from '../../components/TitleCtn'
import type { Produto } from '../../types/produto.props'
import { IconWave } from '../../icons/IconWave'

export function DestaqueMiniatura({
    hostImagem,
    produtos,
    vitrineMacro,
    blackfriday,
    tituloVitrine,
    exibeValoresSomenteLogado,
    precoPrincipal,
    device,
    zordHintLoading,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine,
    width,
    height,
    vitrineButtonAddToCart
}: Readonly<DestaqueMiniaturaProps>) {
    const produtosArray: Produto[] = Array.isArray(produtos) ? produtos : Object.values(produtos) as Produto[]
    const isMobileDevice = [Device.MOBILE, Device.APP, Device.TABLET].includes(device)
    let produtosItens = []

    if (isMobileDevice) {
        produtosItens = produtosArray.slice(0, 4)
    } else {
        produtosItens = produtosArray.slice(1, 4)
    }

    return (
        <>
            {!blackfriday && <TitleCtn tituloVitrine={tituloVitrine} />}

            <div className={`macro-vitrine-1-destaque-3-miniaturas ${vitrineMacro}`}>
                {(produtosArray.length > 0) && (
                    <div className={`box-ofertas-limitadas ${blackfriday ? 'black-ofertas' : ''}`}>
                        {/* class black-ofertas é utilizado em página com o fundo preto normalmente utilizado na blackfriday */}
                        {(blackfriday && !isMobileDevice) && (
                            <div className="wave"><IconWave /></div>
                        )}

                        <div className="container">
                            {blackfriday && (
                                <div className="box-title-oferta">
                                    <span className="icon-dica">
                                        <img
                                            className="lazyload lazyload-svg"
                                            src={isDev() ? getResourceFromS3('assets/global/blackfriday', 'clock.svg') : zordHintLoading}
                                            data-src={getResourceFromS3('assets/global/blackfriday', 'clock.svg')}
                                            alt="Oferta limitada"
                                            width="50"
                                            height="50"
                                        />
                                    </span>
                                    <div>
                                        <h2 className="title-oferta">{tituloVitrine}</h2>
                                        <span className="txt-title">Estas ofertas se encerram em pouco tempo.</span>
                                    </div>
                                </div>
                            )}

                            <div className="box-produtos-ofertas flex center space-between">
                                {!isMobileDevice && (
                                    <ProdutoPrincipal
                                        hostImagem={hostImagem}
                                        produtos={produtosArray}
                                        precoPrincipal={precoPrincipal}
                                        exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                        width={width}
                                        height={height}
                                        hoverImagensVitrine={hoverImagensVitrine}
                                        hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                        utilizaFavoritosVitrine={utilizaFavoritosVitrine}
                                        vitrineButtonAddToCart={vitrineButtonAddToCart}
                                    />
                                )}

                                <div className="produtos-itens">
                                    {blackfriday && (
                                        <span className="txt-resta">Restam poucas unidades</span>
                                    )}

                                    {produtosItens.map((produto) => (
                                        <ItemOferta
                                            key={`${produto.produto_id}-${produto.derivacao_id}`}
                                            hostImagem={hostImagem}
                                            produto={produto}
                                            precoPrincipal={precoPrincipal}
                                            exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                            zordHintLoading={zordHintLoading}
                                            width={width}
                                            height={height}
                                            hoverImagensVitrine={hoverImagensVitrine}
                                            hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                            utilizaFavoritosVitrine={utilizaFavoritosVitrine}
                                            vitrineButtonAddToCart={vitrineButtonAddToCart}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
